import { render, staticRenderFns } from "./editNote.vue?vue&type=template&id=a9b6a420"
import script from "./editNote.vue?vue&type=script&lang=js"
export * from "./editNote.vue?vue&type=script&lang=js"
import style0 from "./editNote.vue?vue&type=style&index=0&id=a9b6a420&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports